<template>
  <div>
    <v-container fluid>
      <v-slide-y-transition mode="out-in">
        <v-layout align-center justify-center>
          <v-flex xs12 sm12>
            <v-card>
              <v-toolbar
                :color="this.getTheme.color"
                prominent
                tabs
                dark
              >
                <v-flex xs12 sm12>
                  <v-form @keyup.enter.native="sendMessage()" action="#" ref="form" lazy-validation @submit.prevent="sendMessage()">
                    <v-text-field
                      ref="name"
                      color=white
                      dark
                      v-model="message"
                      :append-icon="model ? 'arrow_back' : ''"
                      :append-outer-icon="message ? 'mdi-send' : 'search'"
                      :prepend-icon="icon"
                      box
                      clear-icon="mdi-close-circle"
                      clearable
                      :label="changeLabel"
                      type="text"
                      @click:append="toggleMarker"
                      @click:append-outer="sendMessage"
                      @click:prepend="changeIcon"
                      @click:clear="clearMessage"
                    ></v-text-field>
                  </v-form>
                </v-flex>
                <v-tabs
                  slot="extension"
                  :hide-slider="!model"
                  color="transparent"
                  slider-color="blue-grey"
                  v-if="model"
                >
                  <v-tabs-slider color="yellow"></v-tabs-slider>
                  <v-tab href="#tab-1" v-model="navigation" ripple @click.prevent="show(1)">Perfil</v-tab>
                  <v-tab href="#tab-2" v-model="navigation" ripple @click.prevent="show(2)">Prontuário</v-tab>
                  <v-tab href="#tab-3" v-model="navigation" ripple @click.prevent="show(3)">Laudos</v-tab>
                  <!-- <v-tab v-show="attachPatient === true" href="#tab-4" v-model="navigation" ripple @click.prevent="show(4)">Anexos</v-tab> -->
                  <v-tab v-if="env !== 'production'" href="#tab-4" v-model="navigation" ripple @click.prevent="show(4)">Anexos</v-tab>
                  <!-- <v-tab v-if="env !== 'production'" href="#tab-5" v-model="navigation" ripple @click.prevent="show(5)">Cirurgias propostas</v-tab> -->
                </v-tabs>

              </v-toolbar>

              <v-progress-linear :indeterminate="true" v-show="loadingOk === true"></v-progress-linear>

              <v-list two-line v-if="!model" v-show="listVisible">
                <template v-for="(item, index) in items">
                  <v-subheader
                    v-if="item.header"
                    :key="item.header"
                  >
                    Selecione o nome
                    <!-- {{ item.header }} -->
                  </v-subheader>

                  <v-divider
                    v-else-if="item.divider"
                    :key="index"
                    :inset="item.inset"
                  ></v-divider>

                  <v-list-tile
                    v-else
                    :key="item.id"
                    avatar
                    @click="selectPatient(item)"
                  >
                    <v-list-tile-avatar color="indigo">
                      <span class="white--text headline">{{item.symbol}}</span>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title v-html="item.name"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="item.dateOfBirth"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>

              <v-layout row v-show="profile">
                <profile-patient></profile-patient>
              </v-layout>

              <v-layout row v-show="record">
                <record-patient></record-patient>
              </v-layout>

              <v-layout row v-show="examinationReport">
                <examination-report></examination-report>
              </v-layout>

              <v-layout row v-show="image">
                <image-patient></image-patient>
              </v-layout>

              <!-- <v-layout row v-show="proposedSurgeries">
                <surgery-center-list></surgery-center-list>
              </v-layout> -->

            </v-card>
          </v-flex>
        </v-layout>
      </v-slide-y-transition>

    </v-container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import ProfilePatient from '@/components/patient/profile'
  import RecordPatient from '@/components/patient/record'
  import ExaminationReport from '@/components/patient/examinationReport'
  import ImagePatient from '@/components/patient/attachments'
  import SurgeryCenterList from '@/components/surgery-center/list'
  // import store from '../../store'

  export default {
    computed: {
      ...mapGetters('app', ['getTheme', 'getDevice']),
      ...mapGetters('patient', ['getPatient', 'getAttachment']),
      ...mapGetters({
        customer: 'customer',
        auth: 'auth'
      }),
      icon () {
        return this.icons[this.iconIndex]
      },
      changeLabel () {
        let label
        if (this.iconIndex !== 0) {
          label = 'Prontuário'
        } else {
          label = 'Nome/Dt Nasc/Celular/CPF'
        }
        return label
      }
    },
    components: {
      ProfilePatient,
      RecordPatient,
      ImagePatient,
      ExaminationReport,
      SurgeryCenterList
    },
    mounted () {
      this.env = process.env.NODE_ENV
      this.focusInput()
    },
    data: () => ({
      attachPatient: false,
      message: '',
      listVisible: false,
      iconIndex: 0,
      icons: [
        'mdi-ab-testing',
        'mdi-numeric'
      ],
      env: null,
      navigation: 'profile',
      profile: false,
      profileData: {},
      record: false,
      examinationReport: false,
      image: false,
      proposedSurgeries: false,
      miniVariant: true,
      clipped: true,
      drawer: false,
      fixed: false,
      isLoading: false,
      items: [],
      model: null,
      search: null,
      active: null,
      loadingOk: false
    }),
    methods: {
      ...mapActions('medicalRecord', ['setListRecord', 'setAvailableAppointments']),
      ...mapActions('examinationReport', ['setListRecordExam']),
      ...mapActions('patient', ['setPatient', 'setAttachment']),
      selectPatient (item) {
        this.model = item.id
        this.findOne()
      },
      focusInput () {
        this.$refs.name.focus()
      },
      toggleMarker () {
        this.model = undefined
        this.show(0)
        // this.marker = !this.marker
      },
      sendMessage () {
        console.log(this.message)
        this.loadingOk = true
        window.axios.get(`${process.env.URL}/my-clinic-new/patient/find`, {
          params: {
            patient: this.message,
            typeSearch: this.iconIndex,
            customer: this.auth.auth.myClinic.customer

          }
        }).then((response) => {
          // handle success
          this.items = response.data.results.results.map((item) => {
            return {
              id: item.tbCodigo,
              name: item.tbNome,
              symbol: item.tbNome.substr(0, 1),
              website_slug: 'spitzer.io',
              dateOfBirth: item.tbDtNasc
            }
          })
          this.listVisible = true
          this.loadingOk = false
        })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.isLoading = false))
      },
      clearMessage () {
        this.listVisible = false
        this.message = ''
        this.navigation = 'list'
        this.show(0)
      },
      resetIcon () {
        this.iconIndex = 0
      },
      changeIcon () {
        this.iconIndex === this.icons.length - 1
          ? this.iconIndex = 0
          : this.iconIndex++
      },
      medicalRecordEvent (e) {
        this.navigation = e
        this.setPatient(this.model).then(() => {
          this.$bus.$emit('getMedicalRecord', 'profile')
        })
        this.setListRecord(this.model).then(() => {
          this.$bus.$emit('getMedicalRecord', this.navigation)
        })
        // this.setAttachment({ code: this.model, bucket: this.getPatient.bucket }).then(() => {
        //   this.$bus.$emit('getMedicalRecord', this.navigation)
        // })
      },
      next () {
        const active = parseInt(this.active)
        this.active = (active < 2 ? active + 1 : 0)
      },
      show (type) {
        // if (this.model === undefined) return
        if (type === 0) {
          this.profile = false
          this.record = false
          this.image = false
          this.examinationReport = false
          this.model = undefined
          this.medicalRecordEvent('examinationReport')
        } else if (type === 1) {
          this.profile = true
          this.record = false
          this.medicalRecordEvent('profile')
          this.image = false
          this.examinationReport = false
          this.medicalRecordEvent('examinationReport')
        } else if (type === 2) {
          this.profile = false
          this.record = true
          this.medicalRecordEvent('record')
          this.image = false
          this.examinationReport = false
          this.medicalRecordEvent('examinationReport')
        } else if (type === 3) {
          this.profile = false
          this.record = false
          this.image = false
          this.examinationReport = true
          this.proposedSurgeries = false
          this.medicalRecordEvent('examinationReport')
        } else if (type === 4) {
          this.profile = false
          this.record = false
          this.examinationReport = false
          this.image = true
          this.proposedSurgeries = false
          this.medicalRecordEvent('attachments')
        } else if (type === 5) {
          this.profile = false
          this.record = false
          this.examinationReport = false
          this.image = false
          this.proposedSurgeries = true
          // this.medicalRecordEvent('proposed-surgeries')
        }
      },
      findOne () {
        if ((this.model === null) || (this.model === undefined)) return
        this.setPatient(this.model).then(() => {
          this.$bus.$emit('getMedicalRecord', 'profile')
          this.profile = true
          this.setListRecord({ patient: this.model, customer: this.auth.auth.myClinic.customer }).then(() => {})
          this.setListRecordExam({ patient: this.model, customer: this.auth.auth.myClinic.customer }).then(() => {})
          this.setAttachment({code: this.model, bucket: this.getPatient.bucket}).then(() => {})
          if (this.getPatient.bucket) {
            this.attachPatient = true
          } else {
            this.attachPatient = false
          }
        })
      }
    },
    watch: {
      model (val) {
        this.findOne()
      },
      navigation (val) {
      },
      search (val) {
        // Items have already been loaded
        // if (this.items.length > 0) return
        if ((val === null) || (val === undefined)) return
        if (isNaN(val) === false) this.findOne(this.model)

        this.isLoading = true
        console.log(this.auth.auth.myClinic.customer)
        // Lazily load input items
        window.axios.get(`${process.env.URL}/my-clinic-new/patient/find`, {
          params: {
            patient: val,
            customer: this.auth.auth.myClinic.customer // store.state.customer
          }
        }).then((response) => {
          // handle success
          this.items = response.data.results.results.map((item) => {
            return {
              id: item.tbCodigo,
              name: item.tbNome,
              symbol: item.tbNome.substr(1, 0),
              website_slug: 'spitzer.io',
              dateOfBirth: item.tbDtNasc
            }
          })
        })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.isLoading = false))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/patient/index-new.vue